import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex w-full h-full" }
const _hoisted_2 = { class: "flex flex-col mt-auto w-full pt-14 space-y-10" }
const _hoisted_3 = { class: "flex flex-col w-full space-y-14" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col space-y-1"
}
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col space-y-1"
}
const _hoisted_6 = { class: "flex w-full justify-around px-10" }
const _hoisted_7 = { class: "safe-area-bottom grid grid-cols-3 px-5 justify-evenly w-full items-center justify-center my-auto" }
const _hoisted_8 = ["innerHTML"]

import {
  IonButton, modalController, useIonRouter,
} from '@ionic/vue';
import {computed, onMounted, onUnmounted, Ref, ref, watch} from "vue";
import {Preferences} from "@capacitor/preferences";
import {PreferenceKey} from "@/definitions/PreferenceKey";
import {Haptics, ImpactStyle} from "@capacitor/haptics";
import {UserInterface} from "@/interfaces/UserInterface";
import ApiService from "@/services/api/apiService";
import {PluginListenerHandle} from "@capacitor/core";


export default /*@__PURE__*/_defineComponent({
  __name: 'PinPad',
  setup(__props) {

const pad = [
  '1', '2', '3', '4', '5', '6', '7', '8', '9', '', '0', '&larr;'
]

const pin = ref('')

const ionRouter = useIonRouter()

const keyPressed = async (keyIndex: number) => {

  Haptics.impact({style: ImpactStyle.Medium});

  if (keyIndex === 9) return
  if (keyIndex === 11) {
    return pin.value = pin.value.slice(0, pin.value.length - 1)
  }
  if (pin.value.length === 4) return

  pin.value = pin.value + pad[keyIndex]

}

const close = async () => {
  modalController.dismiss()
}

const user: Ref<UserInterface | undefined> = ref()
const listener: Ref<PluginListenerHandle | undefined> = ref()

onMounted(async () => {
  user.value = await ApiService.User().authUser()
  storedPin.value = (await Preferences.get({key: PreferenceKey.PrivacyPin})).value ?? ''
})

const storedPin = ref('')
const storedPinError = ref(false)

const hasPin = computed(() => {
  return storedPin.value.length
})


watch(() => pin.value, async value => {
  if (hasPin.value) {
    if (value.length === 4 && storedPin.value === value) {
      return modalController.dismiss({validated: true})
    }
    if (value.length === 4 && storedPin.value !== value) {
      storedPinError.value = true
      setTimeout(() => {
        pin.value = ''
      }, 50)
      setTimeout(() => {
        storedPinError.value = false
        pin.value = ''
      }, 1000)
      return
    }
  }
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!storedPinError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("div", { class: "text-white text-xl font-semibold w-full text-center" }, "PIN", -1),
              _createElementVNode("div", { class: "text-brand-light-gray text-sm w-full text-center" }, "Please enter your PIN", -1)
            ]))]))
          : _createCommentVNode("", true),
        (storedPinError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "animate-wiggle text-red-600 text-xl font-semibold w-full text-center" }, "Incorrect PIN!", -1),
              _createElementVNode("div", { class: "text-brand-light-gray text-sm w-full text-center" }, "Try again.", -1)
            ]))]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1,2,3,4], (i, index) => {
          return _createElementVNode("div", {
            key: index,
            class: _normalizeClass([{
                    'bg-brand-lime !scale-150' : (pin.value.length-1) >= index,
                  }, "w-3 h-3 scale-100 bg-brand-dark-gray rounded-full transition-all transition-transform"])
          }, null, 2)
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(pad, (key, keyIndex) => {
          return _createVNode(_unref(IonButton), {
            key: keyIndex,
            onClick: ($event: any) => (keyPressed(keyIndex)),
            class: "text-center h-16 flex"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "m-auto font-bold text-white",
                innerHTML: key
              }, null, 8, _hoisted_8)
            ]),
            _: 2
          }, 1032, ["onClick"])
        }), 64))
      ])
    ])
  ]))
}
}

})